import request from '../http.js'


class User{
    userLogin(data) {
        return request.post('/user/login', data)
    }
    selectAllStudent(data) {
        return request.post('/user/student/all', data)
    }
    insertStudent(data) {
        return request.post('/user/student/insert', data)
    }
    deleteStudent(data) {
        return request.post('/user/student/delete', data)
    }
    updateStudent(data) {
        return request.post('/user/student/update', data)
    }
    selectAllClass(data) {
        return request.post('/user/class/all', data)
    }
    changePassword(data) {
        return request.post('/user/password/change', data)
    }
    getScore(data) {
        return request.post('/user/score/get', data)
    }
    insertStudentBatch(data) {
        return request.post('/user/student/insert/batch', data)
    }
}



export default new User()